import React from 'react';
import AppHeader from "../components/AppHeader";
import HorizontalScroll from '../components/HorizontalCards/HorizontalScroll';
import { TutorSearchFilterOptions } from '../components/TutorSearchFilterOptions';
import '../styles/TutorSearchPage.css';


const TutorSearchPage = () => {
    return (
        
        <><div>
            <AppHeader />
       
            {/* Bernard Put Filtering options Component here  */}
            
        </div>
        
        <div className='tutor-filter-options'>
                <TutorSearchFilterOptions />
            </div>
            
            <div className='horizontal-scroll'>

                <HorizontalScroll />
            </div>
            
            </>
    );
};

export default TutorSearchPage;